<ion-footer class="button-container" *ngIf="(leftButton && !leftButton.hidden) || (rightButton && !rightButton.hidden)">
  <ion-buttons>

    <ion-button
      *ngIf="leftButton && !leftButton.hidden"
      [ngClass]="{
        'left-button': true, 
        'compact': leftButton.sizing === 'compact',
        'button-disabled': leftButton.disabled
      }"
      [strong]="true"
      (click)="emitLeftButtonClicked($event)"
    >
      <ion-icon *ngIf="leftButton.icon" name="{{ leftButton.icon }}" slot="start"></ion-icon>
      {{ leftButton.text }}
    </ion-button>

    <ion-button
      *ngIf="rightButton && !rightButton.hidden"
      [ngClass]="{
        'right-button': true,
        'compact': rightButton.sizing === 'compact',
        'button-disabled': rightButton.disabled
      }"
      [strong]="true"
      (click)="emitRightButtonClicked($event)" 
    >
      <ion-icon *ngIf="rightButton.icon" name="{{ rightButton.icon }}" slot="start"></ion-icon>
      {{ rightButton.text }}
    </ion-button>

  </ion-buttons>
</ion-footer>
